import { Component, Input, ChangeDetectorRef, Output, EventEmitter, OnInit } from '@angular/core';
import { ObjectProperties } from '../../../../../../../../../../common/components/data-table/models/column.interface';
import { MenuPosition } from '../../../../../../../../../../common/components/menu/menu-position';
import { PropertyNodeComponent } from './property-node/property-node.component';

@Component({
    selector: 'property-selector',
    templateUrl: './property-selector.component.html',
    styleUrls: ['./property-selector.component.scss'],
    standalone: false
})
export class PropertySelectorComponent implements OnInit {
    public _object: Object;
    position: MenuPosition = { position: 'after', verticalPosition: 'below' };
    @Input()
    propertyPath: string;

    @Input()
    properties: ObjectProperties[];
    @Output()
    selectedProperty: EventEmitter<ObjectProperties> = new EventEmitter();
    @Output()
    itemHoverChanged: EventEmitter<PropertyNodeComponent> = new EventEmitter();
    displayManualPathEntry: boolean = true;

    @Input()
    set object(object: Object) {
        this._object = object;
        this.properties = this._parseObject(this._object);
        this.displayManualPathEntry = false;
    }

    ngOnInit() {
        this.displayManualPathEntry = !this.properties;
    }

    get object() { return this._object; }

    constructor(
        public _changeDetectorRef: ChangeDetectorRef
    ) { }

    public _parseObject(obj: Object, parent: ObjectProperties = { name: '', content: [], path: '$', type: 'object' }): ObjectProperties[] {
        for (let prop in obj) {
            let propertyObj: ObjectProperties = { name: prop, path: `${parent.path}`, content: [], type: typeof obj[prop] };
            if (obj[prop] instanceof Array) {
                propertyObj.path += `[*]`;
                propertyObj.content = this._parseObject(obj[prop], propertyObj);
                parent.content.push(propertyObj);
            }
            else if (obj[prop] instanceof Object) {
                propertyObj.path += `.${prop}`;
                propertyObj.content = this._parseObject(obj[prop], propertyObj);
                parent.content.push(propertyObj);
            } else {
                propertyObj.path += `.${prop}`
                parent.content.push(propertyObj);
            }
        }

        return parent.content;
    }

    generateProperty() {
        let obj = {
            content: [],
            name: this.propertyPath,
            path: this.propertyPath
        } as ObjectProperties;

        this.selectedProperty.emit(obj);
    }
}
